import { render } from "./VStep.vue?vue&type=template&id=cede614c&scoped=true"
import script from "./VStep.vue?vue&type=script&lang=js"
export * from "./VStep.vue?vue&type=script&lang=js"

import "./VStep.vue?vue&type=style&index=0&id=cede614c&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-cede614c"

export default script